import type { LoadFlowSummary } from '.';
import type { CompletedCalculationTactic, VoltageLevel } from '../..';
import type { EvaluationRule } from '../../evaluation/EvaluationRule';
import { RulesProvider } from '../../evaluation/RulesProvider';
import { getLVLoadFlowScenarioSummary } from './lowVoltage/lvSummary';
import { getMVLoadFlowScenarioSummary } from './mediumVoltage/mvSummary';

export function getLoadFlowScenarioSummary(
  calculationTactic: CompletedCalculationTactic,
  evaluationRules: EvaluationRule[],
  scenariosIds: string[],
  voltageLevel: VoltageLevel
): LoadFlowSummary {
  const rulesProvider = RulesProvider.fromRules(evaluationRules);

  switch (voltageLevel) {
    case 'LowVoltage':
      return {
        value: getLVLoadFlowScenarioSummary(
          calculationTactic,
          rulesProvider,
          scenariosIds
        ),
        type: 'LowVoltage'
      };
    case 'MediumVoltage':
      return {
        value: getMVLoadFlowScenarioSummary(
          calculationTactic,
          rulesProvider,
          scenariosIds
        ),
        type: 'MediumVoltage'
      };
    default:
      throw new Error('Unknown voltage level');
  }
}
